import { useSelector } from 'react-redux'
import { Notification } from '../../../common/notification'
import { HandleDetail } from '../../common/handleDetail'
import { selectPeriod } from '../../common/period/slice'
import { TableItem } from './TableItem'
import {
  INDUSTRY_DETAIL_PATH,
  MODEL_ID,
  PORTFOLIO_DETAIL_PATH,
} from './constant'
import {
  selectHighestGrowthIndustryById,
  selectHighestGrowthIndustryIds,
  selectHighestGrowthPortfolioById,
  selectHighestGrowthPortfolioIds,
} from './store/slice'

export const Performance = ({
  isDynamicReport = false,
  hasTablePortfolio = true,
  hasTableIndustry = true,
}) => {
  const period = useSelector(selectPeriod)
  const portfolioIds = useSelector(selectHighestGrowthPortfolioIds)
  const industryIds = useSelector(selectHighestGrowthIndustryIds)

  if (isDynamicReport) {
    const isNoDataPortfolio =
      (hasTablePortfolio && !portfolioIds?.length) || !hasTablePortfolio
    const isNoDataIndustry =
      (hasTableIndustry && !industryIds?.length) || !hasTableIndustry

    if (isNoDataPortfolio && isNoDataIndustry) {
      return <Notification isDynamicReport />
    }
  }

  return (
    <div className={`dFlex gap4 pb2 ${isDynamicReport ? 'flexColumn' : ''}`}>
      {hasTablePortfolio && (
        <div className="flex1 minW0">
          <TableItem
            isDynamicReport={isDynamicReport}
            title="portfolio.summary.HIGHEST_GROWTH_POTENTIAL_PORTFOLIOS"
            note="portfolio.summary.HIGHEST_GROWTH_POTENTIAL_PORTFOLIOS_NOTE"
            indicatorName="PORTFOLIO"
            dataColIds={{
              COL_NUMBER_OF_COMPANIES: 'numberCompanies',
              HIGHEST_GROWTH_POTENTIAL_COMPANIES: 'highestCompanies',
              NEW_HIGHEST_GROWTH_POTENTIAL_COMPANIES: 'newHighestCompanies',
            }}
            ids={portfolioIds}
            getDataFromRedux={selectHighestGrowthPortfolioById}
            renderDetail={({ rowId, colId, data }) => {
              return (
                <HandleDetail
                  path={PORTFOLIO_DETAIL_PATH[colId]}
                  otherParams={{
                    timeFrequency: period,
                    portfolioId: rowId,
                    modelId: MODEL_ID.PERFORMANCE,
                  }}
                  isDynamicReport={isDynamicReport}
                >
                  {data}
                </HandleDetail>
              )
            }}
          />
        </div>
      )}

      {hasTableIndustry && (
        <div className="flex1 minW0">
          <TableItem
            isDynamicReport={isDynamicReport}
            title="portfolio.summary.HIGHEST_GROWTH_POTENTIAL_INDUSTRIES"
            subTitle="portfolio.summary.HIGHEST_GROWTH_POTENTIAL_INDUSTRIES_SUB"
            note="portfolio.summary.HIGHEST_GROWTH_POTENTIAL_INDUSTRIES_NOTE"
            indicatorName="INDUSTRY"
            dataColIds={{
              COL_NUMBER_OF_COMPANIES: 'numberCompanies',
              HIGHEST_GROWTH_POTENTIAL_COMPANIES: 'highestCompanies',
              NEW_HIGHEST_GROWTH_POTENTIAL_COMPANIES: 'newHighestCompanies',
            }}
            ids={industryIds}
            getDataFromRedux={selectHighestGrowthIndustryById}
            renderDetail={({ rowId, colId, data }) => {
              return (
                <HandleDetail
                  path={INDUSTRY_DETAIL_PATH[colId]}
                  otherParams={{
                    timeFrequency: period,
                    vsicId: rowId,
                    modelId: MODEL_ID.PERFORMANCE,
                  }}
                  disabled={colId === 'numberCompanies'}
                  hiddenSelectAll
                  isDynamicReport={isDynamicReport}
                >
                  {data}
                </HandleDetail>
              )
            }}
          />
        </div>
      )}
    </div>
  )
}
